<template>
  <div class="contain-box">
    <!-- 新增资源弹框前端代码  -->
    <!--<el-dialog-->
      <!--:title="asset_add_titlt"-->
      <!--:visible.sync="dialogAdd"-->
      <!--width="1000px"-->
      <!--v-loading="asset_loading"-->
      <!--:close-on-click-modal="false"-->
      <!--top="8vh"-->
      <!--style="padding-bottom: 0px"-->
      <!--append-to-body-->
    <!--&gt;-->
      <el-row v-if="dialogAdd" v-loading="asset_loading" class="contain-box add_box">

        <!--新增资源-主要信息 -->
        <el-tabs v-model="activeName" style="padding: 0px 8px 8px 8px;" ref="tabs">
          <el-tab-pane label="主要信息" name="first">
             <span slot="label">
                  <svg class="icon label-svg" aria-hidden="true" style="">
                      <use class="" xlink:href="#the_third_iconzhuyaozhineng"></use>
                  </svg>
                  主要信息
                </span>
            <div class="form-body" :style="box_style">

              <!--主要信息-->
              <el-form label-width="110px" size="mini" :label-position="labelPosition" :model="asset_main_information"
                       :rules="rules_main_text"
                       ref="asset_main_information">
                <el-row>
                  <el-col :span="12" style="padding: 8px 8px 8px 0px">
                  <el-form-item label="资源名称" prop="server_busi_name">
                    <span slot="label">

                        <svg class="icon " aria-hidden="true" style="width: 1em;height: 1em;top:0px">
                          <use class="" xlink:href="#the_third_iconxingzhuang"></use>
                        </svg>
                        <span>资源名称</span>

                    </span>
                    <el-input type="text" v-model="asset_main_information.server_busi_name"></el-input>
                  </el-form-item>
                  <el-form-item label="IP" v-if="assets_add_edit" prop="server_ip">
                     <span slot="label">

                        <svg class="icon " aria-hidden="true" style="width: 1em;height: 1em;top:0px">
                          <use class="" xlink:href="#the_third_iconIP5"></use>
                        </svg>
                        <span>IP</span>

                    </span>


                    <el-input style="" v-model="asset_main_information.server_ip"
                              placeholder="请输入ip,若主机已经存在可以点击获取按钮获取信息"></el-input>

                  </el-form-item>

                  <el-row>
                    <el-col :span="15">
                      <el-form-item label="系统平台" prop="server_os">

                         <span slot="label">

                            <svg class="icon " aria-hidden="true" style="width: 1em;height: 1em;top:0px">
                              <use class="" xlink:href="#the_third_iconlinux"></use>
                            </svg>
                            <span>系统平台</span>

                        </span>
                        <sys_code_select
                          sys_code_type="server_os_type" :sys_code_has_all="false"
                          :sys_code_style='{"width":"90%"}' v-model="asset_main_information.server_os"
                          :default_value="asset_main_information.server_os"
                          @sys_code_change="server_os_change"
                        ></sys_code_select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="9">
                      <el-form-item label-width="0px" prop="server_os_version">
                        <el-input placeholder="请输入系统版本" v-model="asset_main_information.server_os_version"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item label="资源名称" v-if="assets_add_edit" prop="server_name">
                        <span slot="label">

                            <svg class="icon " aria-hidden="true" style="width: 1em;height: 1em;top:0px">
                              <use class="" xlink:href="#the_third_iconOSzhujimingcheng"></use>
                            </svg>
                            <span>资源名称</span>

                        </span>


                    <el-input v-model="asset_main_information.server_name"></el-input>
                  </el-form-item>
                  <el-form-item label="资源类型" prop="server_virtualization_type">
                      <span slot="label">

                            <svg class="icon " aria-hidden="true" style="width: 1em;height: 1em;top:0px">
                              <use class="" xlink:href="#the_third_iconOSzhujimingcheng"></use>
                            </svg>
                            <span>资源类型</span>

                        </span>
                    <sys_code_select :sys_code_has_all="false"
                                     sys_code_type="server_virtualization_type"
                                     v-model="asset_main_information.server_virtualization_type"
                                     :default_value="asset_main_information.server_virtualization_type"
                    ></sys_code_select>
                  </el-form-item>
                  <el-form-item label="CPU频率" prop="cpu_frequency">
                        <span slot="label">

                        <svg class="icon " aria-hidden="true" style="width: 1em;height: 1em;top:0px">
                          <use class="" xlink:href="#the_third_iconcpu"></use>
                        </svg>
                        <span>CPU频率</span>

                    </span>
                    <el-input v-model="asset_main_information.cpu_frequency"></el-input>
                  </el-form-item>
                  <el-form-item label="CPU核数" prop="cpu_cores">
                      <span slot="label">

                        <svg class="icon " aria-hidden="true" style="width: 1em;height: 1em;top:0px">
                          <use class="" xlink:href="#the_third_iconcpu"></use>
                        </svg>
                        <span>CPU核数</span>

                    </span>
                    <el-input v-model="asset_main_information.cpu_cores"></el-input>
                  </el-form-item>
                  <el-form-item label="硬盘容量GB" prop="disk_total_size">
                     <span slot="label">

                        <svg class="icon " aria-hidden="true" style="width: 1em;height: 1em;top:0px">
                          <use class="" xlink:href="#the_third_iconcipan"></use>
                        </svg>
                        <span>硬盘容量GB</span>

                    </span>
                    <el-input v-model="asset_main_information.disk_total_size"></el-input>
                  </el-form-item>
                  <el-form-item prop="memory_size">
                    <span slot="label">

                        <svg class="icon " aria-hidden="true" style="width: 1em;height: 1em;top:0px">
                          <use class="" xlink:href="#the_third_iconmemavg"></use>
                        </svg>
                        <span>内存GB</span>

                    </span>
                    <el-input v-model="asset_main_information.memory_size"></el-input>
                  </el-form-item>
                  <el-form-item label="激活" prop="is_actived">
                       <span slot="label">

                        <svg class="icon " aria-hidden="true" style="width: 1em;height: 1em;top:0px">
                          <use class="" xlink:href="#the_third_iconjihuo"></use>
                        </svg>
                        <span>激活</span>

                    </span>

                    <el-switch
                      v-model="asset_main_information.is_actived"
                      active-color="#13ce66"
                      inactive-color="#ff4949">
                    </el-switch>
                  </el-form-item>
                </el-col>
                  <el-col :span="12" style="padding: 8px">
                  <el-form-item label="物理位置" prop="location">

                    <span slot="label">

                        <svg class="icon " aria-hidden="true" style="width: 1em;height: 1em;top:0px">
                          <use class="" xlink:href="#the_third_iconwuliweizhi"></use>
                        </svg>
                        <span>物理位置</span>

                    </span>
                    <el-input v-model="asset_main_information.location"></el-input>
                  </el-form-item>
                  <el-form-item label="端口" prop="server_port">
                        <span slot="label">

                        <svg class="icon " aria-hidden="true" style="width: 1em;height: 1em;top:0px">
                          <use class="" xlink:href="#the_third_iconduankou2"></use>
                        </svg>
                        <span>端口</span>

                    </span>


                    <el-input type="text" style="width: 70%" v-model="asset_main_information.server_port"></el-input>
                    <el-button type="primary" size="mini" v-if="seach_or_edit" @click="get_hardware_button">获取</el-button>
                  </el-form-item>
                  <el-form-item label="协议" prop="connect_protocol_type_code">
                       <span slot="label">

                        <svg class="icon " aria-hidden="true" style="width: 1em;height: 1em;top:0px">
                          <use class="" xlink:href="#the_third_iconxieyi"></use>
                        </svg>
                        <span>协议</span>

                    </span>


                    <sys_code_select :sys_code_has_all="false"
                                     sys_code_type="connect_protocol_type"
                                     v-model="asset_main_information.connect_protocol_type_code"
                                     :default_value="asset_main_information.connect_protocol_type_code"
                    ></sys_code_select>
                  </el-form-item>
                  <el-form-item label="公网地址" prop="internet_address">

                     <span slot="label">

                        <svg class="icon " aria-hidden="true" style="width: 1em;height: 1em;top:0px">
                          <use class="" xlink:href="#the_third_icongongwangIP"></use>
                        </svg>
                        <span>公网地址</span>

                    </span>

                    <el-input v-model="asset_main_information.internet_address"></el-input>
                  </el-form-item>

                  <el-form-item label="CPU颗数" prop="cpu_physical_count">


                     <span slot="label">

                        <svg class="icon " aria-hidden="true" style="width: 1em;height: 1em;top:0px">
                          <use class="" xlink:href="#the_third_iconcpu"></use>
                        </svg>
                        <span>CPU颗数</span>

                    </span>
                    <el-input v-model="asset_main_information.cpu_physical_count"></el-input>
                  </el-form-item>
                  <el-form-item label="CPU缓存KB" prop="cpu_cache">

                    <span slot="label">

                        <svg class="icon " aria-hidden="true" style="width: 1em;height: 1em;top:0px">
                          <use class="" xlink:href="#the_third_iconcpu"></use>
                        </svg>
                        <span>CPU缓存KB</span>

                    </span>
                    <el-input v-model="asset_main_information.cpu_cache"></el-input>
                  </el-form-item>
                  <el-form-item label="磁盘数量" prop="disk_count">

                       <span slot="label">

                        <svg class="icon " aria-hidden="true" style="width: 1em;height: 1em;top:0px">
                          <use class="" xlink:href="#the_third_iconcipan"></use>
                        </svg>
                        <span>磁盘数量</span>

                    </span>
                    <el-input v-model="asset_main_information.disk_count"></el-input>
                  </el-form-item>
                  <el-form-item label="逻辑核" prop="cpu_logic_count">
                     <span slot="label">

                        <svg class="icon " aria-hidden="true" style="width: 1em;height: 1em;top:0px">
                          <use class="" xlink:href="#the_third_iconluojihechashezhi"></use>
                        </svg>
                        <span>逻辑核</span>

                    </span>


                    <el-input v-model="asset_main_information.cpu_logic_count"></el-input>
                  </el-form-item>

                </el-col>
                </el-row>
              </el-form>
              <!--主要信息-->

              <el-divider style="margin: 10px 0px;width: 99%;"></el-divider>

              <!--其他信息-->
              <el-form :model="asset_other_information" label-width="120px" size="mini" :label-position="labelPosition"
                       ref="asset_other_information"
                       style="padding: 8px">
                <el-form-item label="系统日志路径" prop="os_log_path">
                  <el-input style="width: 100%" v-model="asset_other_information.os_log_path"></el-input>
                </el-form-item>
                <el-form-item label="标签" v-if="assets_add_edit" prop="label_ids">
                  <label_sys_select
                    label_group_search="asset_type_03" :sys_code_has_all="false" :sys_code_multiple="true"
                    v-model="asset_other_information.label_ids"
                    :default_value="asset_other_information.label_ids"
                    :allow_create="true"
                    @sys_code_change="label_change"
                  ></label_sys_select>

                </el-form-item>
                <el-form-item label="备注" prop="other_comments">
                  <el-input type="textarea" v-model="asset_other_information.other_comments"
                            :rows="4"
                            placeholder="请输入内容" style="width: 100%"></el-input>
                </el-form-item>
              </el-form>
              <!--其他信息-->

            </div>
          </el-tab-pane>

          <!--新增资源-拓补信息 -->
          <el-tab-pane label="拓补信息">

            <span slot="label">
                  <svg class="icon" aria-hidden="true" style="width: 1.3em; height: 1.3em;top: 2px;color: #666">
                      <use class="" xlink:href="#the_third_icontopology"></use>
                    </svg>
                  拓补信息
                </span>
            <el-form
              label-width="120px"
              size="mini"
              :label-position="labelPosition"
              :style="box_style"
              class="form-body"
              :model="asset_topology_information"
              ref="asset_topology_information">

              <el-form-item label="区域" :rules="{
        required: true, message: '区域不能为空', trigger: 'blur'
      }">
                <el-input style="width: 95%" disabled v-model="area_path"></el-input>
              </el-form-item>
              <el-form-item label="Vmware宿主机" prop="host_machine_id">
                <el-select v-model="asset_topology_information.host_machine_id" placeholder="请选择" style="width: 40%"
                           @change='vmware_change'>
                  <el-option
                    v-for="item in host_machine_data"
                    :key="item.server_id"
                    :label="item.server_ip"
                    :value="item.server_id">
                  </el-option>
                </el-select>
                <span style="font-size: 12px;margin: 4px 25px;color: #BCBCBC">非vmware虚拟化主机无需填写此项</span>
              </el-form-item>
              <el-form-item label="父节点" prop="father_node">
                <el-select v-model="asset_topology_information.father_node" multiple placeholder="请选择" style="width: 40%">
                  <el-option
                    v-for="item in assets_add_data"
                    :key="item.server_id"
                    :label="item.server_ip"
                    :value="item.server_id">
                  </el-option>
                </el-select>
                <span style="font-size: 12px;margin: 4px 25px;color: #BCBCBC">父节点描述其上游的基础设施，比如所属宿主机，网络连接交换机等</span><br>
              </el-form-item>
              <el-form-item label="子节点" prop="child_node">
                <el-select v-model="asset_topology_information.child_node" multiple placeholder="请选择" style="width: 40%">
                  <el-option
                    v-for="item in assets_add_data"
                    :key="item.server_id"
                    :label="item.server_ip"
                    :value="item.server_id">
                  </el-option>
                </el-select>
                <span style="font-size: 12px;margin: 4px 25px;color: #BCBCBC">子节点描述其下游基础设置，与父节点对应</span><br/>
              </el-form-item>

            </el-form>
          </el-tab-pane>

          <!--新增资源-用户信息  -->

          <el-tab-pane label="用户信息" v-if="assets_add_edit" name="user">
             <span slot="label">
                  <svg class="icon" aria-hidden="true" style="width: 1.3em; height: 1.3em;top: 2px;color: #666">
                      <use class="" xlink:href="#the_third_iconyonghu7"></use>
                    </svg>
                  用户信息
                </span>


            <div class="form-body" :style="box_style">
              <el-button type="primary" @click="add_user_button" v-if="seach_or_edit" size="mini">绑定系统用户</el-button>
              <el-table
              size="mini"
              :data="asset_user_information"
              height="calc(100% - 30px)"
              style="width: 100%"
              @row-click="getDetails">
              <el-table-column
                prop="default_user"
                width="80px"
                label="默认用户">
                <template slot-scope="server_name">
                  <i style="color: #13CE66;font-size: 18px" v-if="server_name.row.default_user===true"
                     class="el-icon-s-custom" title="默认用户"></i>
                  <!--<span v-else-if="server_name.row.default_user===false" title="非默认用户">    </span>-->
                  <i v-else></i>
                </template>
              </el-table-column>
              <el-table-column
                prop="user_name"
                label="用户名"
                width="110">
              </el-table-column>
              <el-table-column
                prop="ossoft_user_group_id"
                label="用户类型"
                width="120">
              </el-table-column>
              <el-table-column
                prop="user_home"
                width="180px"
                label="用户主目录">
              </el-table-column>
              <el-table-column
                prop="comments"

                label="备注">
              </el-table-column>
              <el-table-column
                prop="addresss"
                width="200"
                label="动作">
                <template slot-scope="scope_user">
                  <el-button type="warning" circle icon="el-icon-omnis-mima" size="mini" v-if="seach_or_edit"
                             @click="edit_user_password_button(scope_user.row)">

                  </el-button>
                  <el-button type="primary" circle icon="el-icon-edit" size="mini" v-if="seach_or_edit"
                             @click="edit_user_button(scope_user.row)">
                  </el-button>
                  <el-button type="danger" circle icon="el-icon-delete" size="mini" v-if="seach_or_edit"
                             @click="delete_user_button(scope_user.row)">
                  </el-button>
                </template>
              </el-table-column>

            </el-table>
            </div>


          </el-tab-pane>

          <!--  新增资源-变更信息 -->

          <el-tab-pane label="变更信息" v-if="assets_add_edit">

              <span slot="label">
                  <svg class="icon" aria-hidden="true" style="width: 1.3em; height: 1.3em;top: 2px;color: #666">
                      <use class="" xlink:href="#the_third_iconicon_zichanguanbiangengshenqing"></use>
                    </svg>
                  变更信息
                </span>

            <div class="form-body" :style="box_style">
              <div align="left" style="width: 10%">
                <omnis_button href="#the_third_iconyishanchu2-copy-copy" button_name="已删除资源" @handle_click="open_delete_diglog"></omnis_button>
              </div>
              <el-table
              size="mini"
              :data="asset_change_information"
              height="calc(100% - 30px)"
              style="width: 100%">
              <el-table-column
                label="时间"
                prop="operator_time"
                width="150">
              </el-table-column>
              <el-table-column
                prop="nick"
                label="操作人"
                width="100">
              </el-table-column>
              <el-table-column
                prop="modify_recoder_type_name"
                width="100"
                label="类型">
              </el-table-column>
              <el-table-column
                width="150"
                prop="modify_property"
                label="修改属性">
              </el-table-column>
              <el-table-column
                prop="modify_before"
                label="修改前">
              </el-table-column>
              <el-table-column
                prop="modify_after"
                label="修改后">
              </el-table-column>

            </el-table>
            </div>


          </el-tab-pane>

        </el-tabs>
        <el-row class="box-footer">
          <div style="background: #F0F8FA;text-align: left;margin-bottom: 4px;" v-if="edit_information_div">
            <span style="font-size: 13px;margin: 4px 10px"> 资源新增时间</span>
            <span style="width: 40px;font-size: 13px">{{asset_add_time}}</span>
            <span style="font-size: 13px;margin: 4px 10px">资源最后修改时间</span>
            <span style="width: 40px;font-size: 13px">{{asset_edit_time}}</span>
              </div>

          <el-button @click="handle_close" size="mini" v-if="seach_or_edit" >关 闭</el-button>
          <el-button type="primary" @click="asset_addall_button('asset_main_information')" v-if="seach_or_edit" size="mini">确 定</el-button>
        </el-row>
      </el-row>
    <!--</el-dialog>-->

    <!-- 删除记录dialog-->
    <el-dialog
      append-to-body
      title="主机删除日志"
      :visible.sync="delete_info_dialog"
      width="50"
      :close-on-click-modal="false"
      top="8vh"
      style="padding-bottom: 0px"
    >
      <el-form :inline="true" :model="server_del_form" class="demo-form-inline" size="mini">
        <el-form-item label="IP">
          <el-input v-model="server_del_form.server_ip" placeholder="资源IP"></el-input>
        </el-form-item>
        <el-form-item label="操作人">
          <user_select :user_options="user_data"
                       v-model="server_del_form.operator_user"
                       ></user_select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="get_server_delete_getData" size="mini">查询</el-button>
        </el-form-item>
      </el-form>

      <el-table
        size="mini"
        :data="server_delete_data"
       :height="server_del_height"
        v-loading="ser_del_loading"
        style="width: 100%">
        <!--<el-table-column-->
          <!--prop="env_info"-->
          <!--label="环境">-->
        <!--</el-table-column>-->
          <el-table-column
            prop="server_name"
            width="180"
            label="资源">
          </el-table-column>
        <el-table-column
            prop="server_ip"
            label="IP">
          </el-table-column>
        <el-table-column
          prop="nick"
          label="操作人"
          width="100">
        </el-table-column>
        <el-table-column
          label="时间"
          prop="operator_time"
          width="150">
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="server_delSizeChange"
        @current-change="server_delCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="del_count">
      </el-pagination>

    </el-dialog>



    <!-- 编辑></编辑>-->
    <!-- 编辑资源弹框前端代码    批量修改 -->
    <!--<el-dialog-->
      <!--:title="asset_add_titlt"-->
      <!--:visible.sync="dialogAdd_edit"-->
      <!--width="900px"-->
      <!--v-loading="asset_loading"-->
      <!--:close-on-click-modal="false"-->
      <!--top="8vh"-->
      <!--style="padding-bottom: 0px"-->
    <!--&gt;-->
    <el-row v-if="dialogAdd_edit" v-loading="asset_loading" class="contain-box batch_add_box">

      <!--新增资源-主要信息 -->
      <el-tabs v-model="activeName" style="padding: 0px 8px 8px 8px;" ref="tabs" v-loading="tab_loading">
        <el-tab-pane label="主要信息" name="first">
          <div class="form-body" :style="box_style">
            <el-form label-width="110px" size="mini" :label-position="labelPosition" :model="asset_main_information"
                     :rules="rules_main_text2"
                     ref="asset_main_information_batch">
              <el-row>
                <el-col :span="12" style="padding: 8px 8px 8px 0px">
                <el-form-item label="物理位置" prop="location">
                  <el-input v-model="asset_main_information.location"></el-input>
                </el-form-item>
                <el-form-item label="系统平台" prop="server_os">
                  <el-col :span="11">
                    <sys_code_select
                      sys_code_type="server_os_type" :sys_code_has_all="false"
                      :sys_code_style='{"width":"90%"}' v-model="asset_main_information.server_os"
                      :default_value="asset_main_information.server_os"
                    ></sys_code_select>
                  </el-col>
                  <el-col :span="13">
                    <el-input placeholder="请输入系统版本" v-model="asset_main_information.server_os_version"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="端口" prop="server_port">
                  <el-input type="text" v-model="asset_main_information.server_port"></el-input>
                </el-form-item>
                <el-form-item label="资源类型" prop="server_virtualization_type">
                  <sys_code_select :sys_code_has_all="false"
                                   sys_code_type="server_virtualization_type"
                                   v-model="asset_main_information.server_virtualization_type"
                                   :default_value="asset_main_information.server_virtualization_type"
                  ></sys_code_select>
                </el-form-item>
                <el-form-item label="CPU频率" prop="cpu_frequency">
                  <el-input v-model="asset_main_information.cpu_frequency"></el-input>
                </el-form-item>
                <el-form-item label="CPU核数" prop="cpu_cores">
                  <el-input v-model="asset_main_information.cpu_cores"></el-input>
                </el-form-item>
                <el-form-item label="硬盘总容量GB" prop="disk_total_size">
                  <el-input v-model="asset_main_information.disk_total_size"></el-input>
                </el-form-item>
                <el-form-item label="物理内存GB" prop="memory_size">
                  <el-input v-model="asset_main_information.memory_size"></el-input>
                </el-form-item>
                <el-form-item label="激活" prop="is_actived">
                  <el-switch
                    v-model="asset_main_information.is_actived"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
                  </el-switch>
                </el-form-item>
              </el-col>
                <el-col :span="12" style="padding: 8px">
                <el-form-item></el-form-item>
                <el-form-item label="协议" prop="connect_protocol_type_code">
                  <sys_code_select :sys_code_has_all="false"
                                   sys_code_type="connect_protocol_type"
                                   v-model="asset_main_information.connect_protocol_type_code"
                                   :default_value="asset_main_information.connect_protocol_type_code"
                  ></sys_code_select>
                </el-form-item>
                <el-form-item label="公网地址" prop="internet_address">
                  <el-input v-model="asset_main_information.internet_address"></el-input>
                </el-form-item>

                <el-form-item label="CPU颗数" prop="cpu_physical_count">
                  <el-input v-model="asset_main_information.cpu_physical_count"></el-input>
                </el-form-item>
                <el-form-item label="CPU缓存kb" prop="cpu_cache">
                  <el-input v-model="asset_main_information.cpu_cache"></el-input>
                </el-form-item>
                <el-form-item label="磁盘数量" prop="disk_count">
                  <el-input v-model="asset_main_information.disk_count"></el-input>
                </el-form-item>
                <el-form-item label="逻辑核" prop="cpu_logic_count">
                  <el-input v-model="asset_main_information.cpu_logic_count"></el-input>
                </el-form-item>

              </el-col>
              </el-row>
            </el-form>

            <el-divider style="margin: 10px 0px;width: 99%;"></el-divider>

            <!--其他信息-->
            <el-form :model="asset_other_information" label-width="110px" size="mini" :label-position="labelPosition"
                     ref="asset_other_information">
              <el-form-item label="标签" v-if="assets_add_edit" prop="label_ids">
                <el-select v-model="asset_other_information.label_ids"
                           @sys_code_change="label_change"
                           multiple
                           placeholder="请选择"
                           style="width:99%">
                  <el-option
                    v-for="item in laber_data"
                    :key="item.label_id"
                    :label="item.label_name"
                    :value="item.label_id">
                  </el-option>
                </el-select>

              </el-form-item>
              <el-form-item label="备注" prop="other_comments">
                <el-input type="textarea" v-model="asset_other_information.other_comments"
                          :rows="4"
                          placeholder="请输入内容" style="width: 99%"></el-input>
              </el-form-item>
            </el-form>
            <!--其他信息-->

          </div>
        </el-tab-pane>

        <!--新增资源-拓补信息 -->
        <el-tab-pane label="拓补信息">
          <el-form label-width="120px"
                   size="mini"
                   :label-position="labelPosition"
                   class="form-body"
                   :style="box_style"
                   :model="asset_topology_information"
                   ref="asset_topology_information">
            <el-form-item label="区域" :rules="{
      required: true, message: '区域不能为空', trigger: 'blur'
    }">
              <el-input style="width: 95%" disabled v-model="area_path"></el-input>
            </el-form-item>
            <el-form-item label="Vmware宿主机" prop="host_machine_id">
              <el-select v-model="asset_topology_information.host_machine_id" placeholder="请选择" style="width: 40%"
                         @change='vmware_change'>
                <el-option
                  v-for="item in host_machine_data"
                  :key="item.server_id"
                  :label="item.server_ip"
                  :value="item.server_id">
                </el-option>
              </el-select>
              <span style="font-size: 12px;margin: 4px 25px;color: #BCBCBC">非vmware虚拟化主机无需填写此项</span>
            </el-form-item>
            <el-form-item label="父节点" prop="father_node">
              <el-select v-model="asset_topology_information.father_node" multiple placeholder="请选择" style="width: 40%">
                <el-option
                  v-for="item in assets_add_data"
                  :key="item.server_id"
                  :label="item.server_ip"
                  :value="item.server_id">
                </el-option>
              </el-select>
              <span style="font-size: 12px;margin: 4px 25px;color: #BCBCBC">父节点描述其上游的基础设施，比如所属宿主机，网络连接交换机等</span><br>
            </el-form-item>
            <el-form-item label="子节点" prop="child_node">
              <el-select v-model="asset_topology_information.child_node" multiple placeholder="请选择" style="width: 40%">
                <el-option
                  v-for="item in assets_add_data"
                  :key="item.server_id"
                  :label="item.server_ip"
                  :value="item.server_id">
                </el-option>
              </el-select>
              <span style="font-size: 12px;margin: 4px 25px;color: #BCBCBC">子节点描述其下游基础设置，与父节点对应</span><br/>
            </el-form-item>
          </el-form>
        </el-tab-pane>

      </el-tabs>
      <div class="box-footer">
        <el-button @click="handle_close" size="mini" v-if="seach_or_edit">关 闭</el-button>
        <el-button type="primary" @click="asset_addall_button('asset_main_information_batch')" v-if="seach_or_edit" size="mini">确 定</el-button>
      </div>
    </el-row>
    <!--</el-dialog>-->

    <!--  新增资源-用户信息 -新增用户 -->
    <el-dialog
      append-to-body
      class="asset_user_from"
      :title="asset_user_title"
      :visible.sync="dialogAdd_user"
      :close-on-click-modal="false"
      width="800px">
      <el-form label-width="100px" size="mini" status-icon :model="asset_user_from" ref="asset_user_from" :rules="rules"
               :label-position="labelPosition" style="padding: 8px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户名" prop="user_name">
              <el-input style="width: 95%" v-model="asset_user_from.user_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户类型" prop="ossoft_user_group_id">
              <el-select v-model="asset_user_from.ossoft_user_group_id"
                         style="width: 95%"
                         :default_value="asset_user_from.ossoft_user_group_id"
                         placeholder="请选择">
                <el-option
                  v-for="item in ossoft_user_options"
                  :key="item.ossoft_user_group_id"
                  :label="item.user_group_name"
                  :value="item.ossoft_user_group_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="用户主目录" prop="user_home">
          <el-input style="width: 98%" v-model="asset_user_from.user_home"></el-input>

        </el-form-item>

        <el-form-item label="默认用户" prop="default_user">
          <el-checkbox v-model="asset_user_from.default_user"></el-checkbox>
          <span style="font-size: 12px;margin: 4px 25px;color: #BCBCBC">默认用户在一些未指定用户登录的场景下使用此用户登录</span>
        </el-form-item>

        <el-form-item label="备注" prop="comments">
          <el-input v-model="asset_user_from.comments" style="width: 98%"></el-input>
        </el-form-item>

        <el-divider></el-divider>

        <el-row>
          <el-col :span="12">
            <el-form-item label="密码" prop="user_pwd">
              <el-input style="width:95%" type="password" v-model="asset_user_from.user_pwd"
                        autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="重复密码" prop="user_pwd2">
              <el-input type="password" style="width: 95%" v-model="asset_user_from.user_pwd2"
                        autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogAdd_user = false" size="small" style="margin-top: 15px">取 消</el-button>
          <el-button type="primary" size="small" @click="submitForm('asset_user_from')">确 定</el-button>
      </span>
    </el-dialog>


    <!-- 更新资源-用户信息 -修改用户 -->
    <el-dialog
      append-to-body
      :title="asset_user_title"
      :visible.sync="dialogedit_user"
      :close-on-click-modal="false"
      width="800px">
      <el-form label-width="100px" size="mini" status-icon :model="asset_user_from" ref="asset_user_from"
               :rules="rules_edit"
               :label-position="labelPosition" style="padding: 8px">
        <el-row>
          <el-col :span="11">
            <el-form-item label="用户名" prop="user_name">
              <el-input style="width: 90%" v-model="asset_user_from.user_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户类型" prop="ossoft_user_group_id">
              <el-select v-model="asset_user_from.ossoft_user_group_id" placeholder="请选择">
                <el-option
                  v-for="item in ossoft_user_options"
                  :key="item.ossoft_user_group_id"
                  :label="item.user_group_name"
                  :value="item.ossoft_user_group_id">
                </el-option>
              </el-select>
              <!--<sys_code_select sys_code_type="os_privileage_code" :sys_code_has_all="false" default_label_name='false'-->
                               <!--@sys_code_change="user_type_change"-->
                               <!--:default_value="asset_user_from.os_privileage_code"-->
                               <!--v-model="asset_user_from.os_privileage_code"></sys_code_select>-->
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="用户主目录" prop="user_home">
          <el-input style="width: 45%" v-model="asset_user_from.user_home"></el-input>

        </el-form-item>

        <el-form-item label="默认用户" prop="default_user">
          <el-checkbox v-model="asset_user_from.default_user"></el-checkbox>
          <span style="font-size: 12px;margin: 4px 25px;color: #BCBCBC">默认用户在一些未指定用户登录的场景下使用此用户登录</span>
        </el-form-item>

        <el-form-item label="备注" prop="comments">
          <el-input v-model="asset_user_from.comments" style="width: 95%"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="submitForm('asset_user_from')"
                     style="float: right;margin-left: 10px">确 定
          </el-button>
          <el-button @click="dialogedit_user = false" size="small" style="float: right">取 消</el-button>
        </el-form-item>


      </el-form>
    </el-dialog>

    <el-dialog
      append-to-body
      title="修改密码"
      :visible.sync="edit_user_password"
      :close-on-click-modal="false"
      width="600px">
      <el-form label-width="100px" size="mini" status-icon :model="user_password_form" ref="user_password_form"
               :rules="rules_password"
               :label-position="labelPosition" style="padding: 8px">

        <el-form-item label="密码" prop="user_pwd">
          <el-input type="password" style="width: 95%" v-model="user_password_form.user_pwd"
                    show-password=""></el-input>

        </el-form-item>

        <el-form-item label="确认" prop="user_pwd2">
          <el-input type="password" style="width: 95%" v-model="user_password_form.user_pwd2"
                    show-password=""></el-input>

        </el-form-item>


        <el-form-item>
          <el-button type="primary" size="small"
                     v-loading="loading_update_password"
                     @click="update_password()"
                     style="float: right;margin-left: 10px">确 定
          </el-button>
          <el-button @click="edit_user_password = false" size="small" style="float: right">取 消</el-button>
        </el-form-item>


      </el-form>
    </el-dialog>

  </div>
</template>
<script>
  import * as API from "@/api/index.js"
  import sys_code_select from "@/components/common_page/sys_code_select"
  import label_sys_select from "@/components/common_page/label_sys_select"
  import omnis_button from "@/components/common_page/omnis_button"
  import * as COMMON from "@/common/index.js"
  import user_select from "@/components/common_page/user/user_select"

  export default {
    components: {
      sys_code_select,
      label_sys_select,
      omnis_button,
      user_select,
    },
    props: {
      server_data: {}
    },

    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '' || value === undefined) {
          callback(new Error('请输入密码'));
        } else {
          if (this.asset_user_from.user_pwd2 !== '') {
            this.$refs.asset_user_from.validateField('user_pwd2');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '' || value === undefined) {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.asset_user_from.user_pwd) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      var re = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;//正则表达式
      var validatePass3 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入IP'));
        } else if (re.test(value)) {
          if (RegExp.$1 < 256 && RegExp.$2 < 256 && RegExp.$3 < 256 && RegExp.$4 < 256) {
            callback();
          } else {
            callback(new Error('ip格式输入有误!'));
          }
        } else {
          callback(new Error('ip格式输入有误!'));
        }
      };
      var validatePass4 = (rule, value, callback) => {
        if (value === '' || value === undefined) {
          callback(new Error('端口号不能为空'));
        } else {
          // if (/^(\d{1,4}|10000)$/.test(value) == false) {
          //   callback(new Error('端口号输入格式错误!'));
          // } else {
            callback();
          // }
        }
      };
      var validatePass5 = (rule, value, callback) => {
        if (/^(\d{1,4}|10000)$/.test(value) == false) {
          if (value === '') {
            callback();
          } else {
            callback(new Error('端口号输入格式错误!'));
          }

        } else {
          callback();
        }
      };
      return {
        ser_del_loading:false,
        currentPage:1,
        del_page:1,
        del_size:20,
        del_count:0,
        user_loading:false,
        server_delete_data:[],
        user_data:[],
        server_del_form:{
          operator_user:'',
          server_ip:''
        },
        ossoft_user_options:[],
        current_user: {},
        loading_update_password: false,
        edit_user_password: false,
        tab_loading:false,
        dialogedit_user: false,
        server_del_height:(COMMON.getTableHeight(-350)) + "px",
        updateQusRulesList: {},
        server_ids: [],
        server_env_id: '',              //主页面的环境id
        server_id: '',
        //资源新增
        dialogAdd: false,              //资源新增弹框的打开和关闭参数
        asset_loading: false,
        edit_information_div: false,
        asset_add_titlt: '资源新增',     //资源新增弹框的title
        seach_or_edit: true,              //资源新增提交按钮的显示和隐藏
        dialogAdd_user: false,
        activeName: 'first',           //资源新增弹框里面打开时显示的tab的name
        assets_add_edit: true,         //资源新增和修改的显示判断
        asset_add_time: '',              //资源弹框里面的资源新增时间
        asset_edit_time: '',             //资源弹框里面的资源最后修改时间
        asset_user_title: '绑定系统用户',
        dialogAdd_edit: false,
        delete_info_dialog:false,
        select_user_name: '',
        asset_user_information: [],     //资源新增---用户信息table的数据
        user_password_form: {
          server_os_users_id: "",
          user_pwd: '',
          user_pwd2: ''
        },
        asset_user_from: {               //资源新增里面用户信息form的数据
          user_name: '',
          ossoft_user_group_id: '',
          os_privileage_text: '',
          user_home: '',
          default_user: '',
          comments: '',
          user_pwd: '',
          user_pwd2: '',
          server_os_users_id: '',
          server_os_user_id: '',
        },

        serch_shell: '',                 //资源新增---用户新增获取创建脚本按钮获取的创建信息

        asset_main_information: {       //资源新增--主要信息的数据
          server_ip: '',
          server_name: '',
          server_os: '',
          server_os_version: '',
          server_port: '',
          internet_address: '',
          server_virtualization_type: '',
          is_actived: true,
          cpu_cores: '',
          cpu_frequency: '',
          cpu_physical_count: '',
          cpu_logic_count: '',
          connect_protocol_type_code: '',
          cpu_cache: '',
          disk_total_size: '',
          disk_count: '',
          memory_size: '',
          server_hardware_id: '',
          server_os_users_id: '',
          location: '',
          server_busi_name: ''
        },
        asset_topology_information: {           //资源新增---拓补信息
          father_node: [],
          child_node: [],
          host_machine_id: '',
          host_machine_ip: '',
        },
        host_machine_data: [],               //拓补信息里面的Vmware的下拉框数据
        assets_add_data: [],                //拓补信息里面的父节点，子节点的下拉框数据
        area_path: '',                          //资源新增---拓补信息--区域

        laber_data: [],                          //资源新增---其他信息---标签数据
        asset_other_information: {           //资源新增---其他信息
          os_log_path: '',	                  //日志路径
          other_comments: '',              	//	备注
          label_ids: [],
        },

        asset_change_information: [],      //资源新增--变更信息
        labelPosition: 'left',              //form表单label靠左对齐

        rules: {
          user_pwd: [
            {validator: validatePass, trigger: 'blur', required: true}
          ],
          user_pwd2: [
            {validator: validatePass2, trigger: 'blur', required: true}
          ],
          user_name: [
            {required: true, message: '用户名不能为空', trigger: 'blur'}
          ],
          user_home: [
            {required: true, message: '用户主目录不能为空', trigger: 'blur'}
          ],
          ossoft_user_group_id: [
            {required: true, message: '用户类型不能为空', trigger: 'blur'}
          ],
//          create_shell: [
//            {required: true, message: '创建脚本不能为空', trigger: 'blur'}
//          ],
        },
        rules_password: {
          user_pwd: [
            {
              validator: (rule, value, callback) => {
                if (value === '' || value === undefined) {
                  callback(new Error('请输入密码'));
                } else {
                  if (this.user_password_form.user_pwd2 !== '') {
                    this.$refs.user_password_form.validateField('user_pwd2');
                  }
                  callback();
                }
              }, trigger: 'blur', required: true
            }
          ],
          user_pwd2: [
            {
              validator: (rule, value, callback) => {
                if (value === '' || value === undefined) {
                  callback(new Error('请再次输入密码'));
                } else if (value !== this.user_password_form.user_pwd) {
                  callback(new Error('两次输入密码不一致!'));
                } else {
                  callback();
                }
              }, trigger: 'blur', required: true
            }
          ],

        },
        rules_edit: {
          user_pwd: [
            {validator: validatePass, trigger: 'blur', required: true}
          ],
          user_pwd2: [
            {validator: validatePass2, trigger: 'blur', required: true}
          ],
          user_name: [
            {required: true, message: '用户名不能为空', trigger: 'blur'}
          ],
          user_home: [
            {required: true, message: '用户主目录不能为空', trigger: 'blur'}
          ],
          ossoft_user_group_id: [
            {required: true, message: '用户类型不能为空', trigger: 'blur'}
          ],
        },
        rules_main_text2: {
          server_port: [
            {validator: validatePass5, trigger: 'blur'}
          ]
        },
        rules_main_text: {
          server_ip: [
            {validator: validatePass3, trigger: 'blur', required: true}
          ],
          server_os: [
            {required: true, message: '系统平台不能为空', trigger: ['blur', 'change']}
          ],
          server_busi_name: [
            {required: true, message: '资源名称不能为空', trigger: 'blur'}
          ],
          server_port: [
            {validator: validatePass4, trigger: 'blur', required: true}
          ],
          server_virtualization_type: [
            {required: true, message: '资源类型不能为空', trigger: ['blur', 'change']}
          ],
          server_name: [
            {required: true, message: '资源名称不能为空', trigger: 'blur'}
          ],
          connect_protocol_type_code: [
            {required: true, message: '协议不能为空', trigger: ['blur', 'change']}
          ],
        },
        label_list:[],   // 标签数据
        new_label_data:[],   // 自定义的新标签

        box_style:{
          height: "500px",
        },
        first:false,
      }

    },

    watch:{

      server_data: {
        handler: function (data) {
          this.asset_information_search(data)
        },
        deep: true,

      },

      dialogAdd(val){
        if(val){
          this.get_box_height("add_box")
        }

      },

      dialogAdd_edit(val){
        if(val){
          this.get_box_height("batch_add_box")
        }

      },

    },

    computed: {},
    mounted() {

      // this.laber_getData()
       this.queryUserData()
      this.get_label_data()
    },
    created(){
      this.query_soft_user_group()
    },
    methods: {

      reset_asset_main_info(){
        this.asset_main_information = {
          server_ip: '',
          server_name: '',
          server_os: '',
          server_os_version: '',
          server_port: '',
          internet_address: '',
          server_virtualization_type: '',
          is_actived: true,
          cpu_cores: '',
          cpu_frequency: '',
          cpu_physical_count: '',
          cpu_logic_count: '',
          connect_protocol_type_code: '',
          cpu_cache: '',
          disk_total_size: '',
          disk_count: '',
          memory_size: '',
          server_hardware_id: '',
          server_os_users_id: '',
          location: '',
          server_busi_name: ''
        }
      },

      // 设置tab标签页内容高度
      get_box_height(class_name){
        this.$nextTick(() =>{
          // if(!this.first){
            setTimeout(() =>{
              var tab_header_height = this.$el.querySelector("." + class_name).querySelector(".el-tabs__header").offsetHeight
              var footer_height = this.$el.querySelector("." + class_name).querySelector(".box-footer").offsetHeight
              this.box_style.height = this.$el.querySelector("." + class_name).offsetHeight - tab_header_height - 86 - 10 + "px";
            }, 300)


            // this.first = true
          // }

        })
      },

      // 关闭页面
      handle_close(){
        this.box_all_close()
        this.$emit("handle_close")
      },

      box_all_close(){
        this.dialogAdd = false
        this.dialogAdd_edit = false
      },

      // 标签选择数据改变时
      label_change(data, selected_labels, new_labels){
        this.new_label_data = new_labels
      },

      update_password() {

        this.$refs["user_password_form"].validate((valid) => {

          if (valid) {

            this.current_user.user_pwd = this.user_password_form.user_pwd
            this.edit_user_password = false
          } else {
            return false;
          }
        });
      },
      update_password_data() {
        //  this.edit_user_password = false
        //  this.loading_update_password= true
        //  const  response = await API.PUT("/omnis/assets_operations/asset_management/server_os_user/user_password/",this.user_password_form)
        // this.loading_update_password= false
        //  var data = response.data
        //  if(data.success){
        //    this.loading_update_password = false

        //   this.$message.success(data.msg);
        // }else {
        //   this.$message.error(data.msg);
        // }
      },
      edit_user_password_button(data) {
        this.current_user = data
        this.edit_user_password = true

        this.user_password_form = Object.assign(this.user_password_form, data)
        this.user_password_form.user_pwd = ""
        this.user_password_form.user_pwd2 = ""
      },

      //资源管理----资源新增按钮的点击事件
      add_asset_button() {
        this.dialogAdd = true
        this.activeName = 'first'
        this.edit_information_div = false
        this.asset_add_titlt = '资源新增'     //资源新增的title
        this.seach_or_edit = true                 //提交按钮的显示
        this.dialogAdd_edit = false
        this.$nextTick(() =>{
          this.resetForm('asset_main_information')
          this.resetForm('asset_other_information')
          this.resetForm('asset_topology_information')
          this.reset_asset_main_info()
          this.asset_user_information = []
          this.asset_change_information = []
        })

      },

      //批量提交----批量修改
      batch_edit_button() {

        this.activeName = 'first'
        //     this.user_add_edit = false
//        this.dialogAdd = true
        this.edit_information_div = true
        this.asset_add_titlt = '批量修改'
        this.seach_or_edit = true
        this.dialogAdd_edit = true
        this.dialogAdd = false
        this.$nextTick(() =>{

          this.resetForm('asset_main_information_batch')
          this.resetForm('asset_other_information')
          this.resetForm('asset_topology_information')
          this.reset_asset_main_info()
          this.asset_user_information = []
          this.asset_change_information = []
        })

      },
      //资源管理---信息表主机名的点击事件
      asset_information_search(data) {
        this.activeName = 'first'
        this.server_id = data.server_id
        //      this.assets_add_edit = true
        this.asset_add_titlt = '资源查看'
        this.dialogAdd = true
        this.seach_or_edit = false
        this.$nextTick(() =>{
          this.resetForm('asset_main_information')
          this.resetForm('asset_other_information')
          this.resetForm('asset_topology_information')
          this.reset_asset_main_info()
          this.asset_user_information = []
          this.asset_search_getData()
        })

      },

      //资源管理--信息表更新按钮
      update_asset(data) {

        this.activeName = 'first'
        this.dialogAdd = true
        this.dialogAdd_edit = false
        this.edit_information_div = true
        this.asset_add_titlt = '资源更新'
        this.seach_or_edit = true
        this.server_id = data.server_id
        this.$nextTick(() =>{
          this.resetForm('asset_main_information')
          this.resetForm('asset_other_information')
          this.resetForm('asset_topology_information')
          this.reset_asset_main_info()

          // this.$nextTick(() => {
            this.asset_user_information = []

            this.asset_search_getData()
          // })



        })

      },
      //更新按钮---资源数据查询
      async asset_search_getData() {
        this.asset_loading = true
        // this.tab_loading = true
        var datas = {'server_id': this.server_id,}
        const response = await API.GET('/omnis/assets_operations/new_assets/host_main', datas)
        // this.tab_loading = false
        this.asset_loading = false
        if (response && response.data) {
          var data = response.data
          if (data.success) {
            this.$nextTick(() => {
              this.asset_main_information = data.data.main_information
              this.asset_other_information = data.data.other_information
              this.asset_topology_information = data.data.topology_information
              this.asset_user_information = data.data.user_information
              this.asset_change_information = data.data.change_info
              this.asset_add_time = data.data.create_time
              this.asset_edit_time = data.data.modify_time
            })

          } else {
            this.$message.error(data.msg);
          }
        } else {
          this.$message.error('系统错误');
        }
      },

      async query_soft_user_group(){
        const response = await API.GET('/omnis/webshell_management/soft_user_group')
        if (response && response.data) {
          this.ossoft_user_options = response.data.data
        } else {
          this.$message.error(response.data.msg);
        }
      },

      //资源新增--拓补信息--Vmware宿主机下拉框的change事件(主要是获取主机的ip)
      vmware_change(val) {
        var obj = {};
        obj = this.host_machine_data.find(item => {
          return item.server_id === val
        });
        this.asset_topology_information.host_machine_ip = obj.server_ip
      },

      //资源管理--拓补信息——Vmware宿主机下拉框获取数据
      async wmware_getData() {
        var datas = {'server_env_id': this.server_env_id}
        const response = await API.GET('/omnis/assets_operations/new_assets/get_machine_host', datas)
        if (response && response.data) {
          var data = response.data
          if (data.success) {
            this.host_machine_data = data.data
          } else {
            this.$message.error(data.msg);
          }
        } else {
          this.$message.error('系统错误');
        }
      },


      //资源管理--资源新增确定按钮点击事件
      asset_addall_button(ref_name) {
        this.$refs[ref_name].validate((valid) => {
          if (valid) {
            this.asset_addall_getData()
          } else {
            this.activeName = 'first'
            return false;
          }
        });
      },
      //资源管理--资源新增确定按钮点击事件接口请求
      async asset_addall_getData() {
        this.asset_loading = true
        var other_information = Object.assign({}, this.asset_other_information)
        if(this.new_label_data.length > 0){
          other_information.new_labels = this.new_label_data
        }
        var datas = {
          'main_information': this.asset_main_information,
          'user_information': this.asset_user_information,
          'other_information': other_information,
          'topology_information': this.asset_topology_information,
          'server_env_id': this.server_env_id
        }
        var datas_edit = {
          'main_information': this.asset_main_information,
          'other_information': other_information,
          'topology_information': this.asset_topology_information,
          'server_env_id': this.server_env_id,
          'server_ids': this.server_ids
        }
        var url = ''
        if (this.asset_add_titlt === '资源新增') {
          url = await API.POST('/omnis/assets_operations/new_assets/host_main', datas)
        }
        if (this.asset_add_titlt === '资源更新') {
          url = await API.PUT('/omnis/assets_operations/new_assets/host_main', datas)
        }
        if (this.asset_add_titlt === '批量修改') {
          url = await API.PUT('/omnis/assets_operations/batch_operation/batch_alter_hostinfo', datas_edit)
        }
        const response = url
        this.asset_loading = false
        if (response && response.data) {
          var data = response.data
          if (data.success) {
            this.$message.success(data.msg);
            // this.dialogAdd = false
            // this.dialogAdd_edit = false
            this.handle_close()
            this.$emit('asset_getData');
          } else {
            this.$message.error(data.msg);
          }
        } else {
          this.$message.error('系统错误');
        }
      },

      //资源管理--新增资源——主要信息获取按钮的点击事件
      get_hardware_button() {
        var flag_index = []
        for (var i = 0; i < this.asset_user_information.length; i++) {
          if (this.asset_user_information[i].user_name === 'root') {
            flag_index.push(this.asset_user_information[i])
          }
        }
        if (flag_index.length === 1) {
          this.get_hardware_getData(flag_index)
        } else {
          this.$message.error('获取主机需要填写包含root的用户信息!请在用户信息里面进行添加,且请勿维护多个同名用户')
          this.activeName = 'user'
        }
      },
      //资源管理--新增资源——主要信息获取按钮获取硬件信息
      async get_hardware_getData(flag_index) {
        this.asset_loading = true
        var datas = {
          'ip': this.asset_main_information.server_ip,
          'port': this.asset_main_information.server_port,
          'user_name': flag_index[0].user_name,
          'pwd': flag_index[0].user_pwd,
        }
        const response = await API.GET('/omnis/assets_operations/new_assets/get_hard', datas)
        this.asset_loading = false
        if (response && response.data) {
          var data = response.data
          if (data.success) {
            //        data.data.server_id=this.asset_main_information.server_id
            data.data.connect_protocol_type_code = this.asset_main_information.connect_protocol_type_code
            data.data.server_port = this.asset_main_information.server_port
            data.data.internet_address = this.asset_main_information.internet_address
            data.data.server_ip = this.asset_main_information.server_ip
            data.data.is_actived = this.asset_main_information.is_actived
            data.data.server_id = this.asset_main_information.server_id
            data.data.server_os_users_id = this.asset_main_information.server_os_users_id
            data.data.server_service_type = this.asset_main_information.server_service_type
            data.data.server_hardware_id = this.asset_main_information.server_hardware_id
            data.data.server_busi_name = this.asset_main_information.server_busi_name
            data.data.location = this.asset_main_information.location
            this.asset_main_information = data.data
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg);
          }
        } else {
          this.$message.error('系统错误');
        }
      },

      //资源管理--新增资源——用户信息增删改查
//      formatter_user(row, column) {
//        if (row.default_user) {
//          return ''
//        } else {
//          return '<i class="el-icon-user"  title="非默认用户"></i>'
//        }
//      },

      getDetails(row) {
        this.select_user_name = row.user_name
        this.asset_user_from = Object.assign({}, row)//对象克隆
      },
      add_user_button() {
        this.asset_user_title = '绑定系统用户'
        this.resetForm('asset_user_from')
        this.dialogAdd_user = true
        this.asset_user_from.user_pwd = ''
        this.asset_user_from.user_pwd2 = ''
        this.asset_user_from.ossoft_user_group_id = ''
        this.asset_user_from.user_name = ''
        this.asset_user_from.user_home = ''
      },


      edit_user_button(data) {
        this.asset_user_title = '用户修改'
//        if (this.asset_add_titlt === '资源新增' || data.asser_user_change === '1') {
        if (this.asset_add_titlt === '资源新增') {
          this.dialogAdd_user = true
        } else {
          this.dialogedit_user = true
        }
        this.asset_user_from = data
      },
      delete_user_button(data) {
        for (var i = 0; i < this.asset_user_information.length; i++) {
          if (this.asset_user_information[i].user_name === data.user_name) {
            this.asset_user_information.splice(i, 1)
          }
        }
      },
      user_type_change(sys_code, selected_item) {
        console.log(sys_code, selected_item)
        this.asset_user_from.os_privileage_text = selected_item.sys_code_text
      },

      //资源管理--新增资源——用户信息新增按钮点击事件
      submitForm(formName) {
        var json_form = JSON.parse(JSON.stringify(this.asset_user_information))
        var json = JSON.parse(JSON.stringify(this.asset_user_from))
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.asset_user_title === '绑定系统用户') {
              for (var i = 0; i < this.asset_user_information.length; i++) {
                if (this.asset_user_information[i].user_name === json.user_name) {
                  this.$message.error('用户名已经存在');
                  return false
                }
              }
              this.$nextTick(() => {
                if (this.asset_add_titlt === '资源新增') {
                  json.asser_user_change = '1'
                }
                if (this.asset_add_titlt === '资源更新') {
                  json.asser_user_change = '1'
                }
                if (json.default_user) {
                  for (var j = 0; j < json_form.length; j++) {
                    if (json_form[j].default_user) {
                      json_form[j].default_user = false
                    }
                  }
                }
                json_form.push(json)
                this.asset_user_information = json_form
              })
              this.dialogAdd_user = false
            }
            if (this.asset_user_title === '用户修改') {
              for (var i = 0; i < this.asset_user_information.length; i++) {
                if (this.asset_user_information[i].user_name === this.select_user_name) {
                  if (this.select_user_name === json.user_name) {
                    if (json.asser_user_change === '1') {

                    } else {
                      json.asser_user_change = '2'
                    }
                    if (json.default_user) {
                      for (var g = 0; g < json_form.length; g++) {
                        if (json_form[g].default_user) {
                          if (g != i) {
                            json_form[g].default_user = false
                          }
                        }
                      }
                    }
                    json_form.splice(i, 1, json)
                    this.asset_user_information = json_form
//                    if (this.asset_add_titlt === '资源新增' || json.asser_user_change === '1') {
                    //                   if (this.asset_add_titlt === '资源新增') {
                    this.dialogAdd_user = false
                    //                  } else {
                    this.dialogedit_user = false
                    //                      this.dialogAdd_user = false
                    //                  }
                  } else {
                    for (var j = 0; j < this.asset_user_information.length; j++) {
                      if (this.asset_user_information[j].user_name === json.user_name) {
                        this.$message.error('用户名已经存在');
                        return false
                      }
                    }
                    if (json.asser_user_change === '1') {

                    } else {
                      json.asser_user_change = '2'
                    }
                    if (json.default_user) {
                      for (var g = 0; g < json_form.length; g++) {
                        if (json_form[g].default_user) {
                          if (g != i) {
                            json_form[g].default_user = false
                          }
                        }
                      }
                    }
                    json_form.splice(i, 1, json)
                    this.asset_user_information = json_form
                    this.dialogAdd_user = false
                    this.dialogedit_user = false
                  }
                }
              }
            }
            console.log(this.asset_user_information)
          } else {
            return false;
          }
        });
      },


      //form表单的重置
      resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
              this.$refs[formName].resetFields();
            }

      },
      server_os_change(sys_code){

          if(sys_code == 'centos'){
              this.asset_main_information.connect_protocol_type_code = 'ssh'
          }
          else if(sys_code == 'windows'){
              this.asset_main_information.connect_protocol_type_code = 'telnet'
          }
      },
      //获取删除主机的记录
      async get_server_delete_getData() {
        this.server_del_form.page = this.del_page;
        this.server_del_form.size = this.del_size;
        this.server_del_form.server_env_id = this.server_env_id
        this.ser_del_loading = true
        const response = await API.GET('/omnis/assets_operations/query_server_delete_data', this.server_del_form);
        this.ser_del_loading = false
        if (response && response.data) {
          var data = response.data;
          if (data.success) {
            this.server_delete_data = data.data
            this.del_count = data.count
          } else {
            this.$message.error(data.msg);
          }
        }

      },
      open_delete_diglog(){
        this.get_server_delete_getData()
        this.delete_info_dialog= true
      },
      server_delSizeChange(size) {
        this.del_size = size;
        this.get_server_delete_getData(this.war_artifactid)
      },
      server_delCurrentChange(page) {
        this.del_page = page;
        this.get_server_delete_getData(this.war_artifactid)
      },
      async queryUserData() {

        var datas = {"type": "all"}
        this.user_loading = true
        const response = await API.GET('/omnis/system/user_management/', datas)
        this.user_loading = false
        if (response && response.data) {
          var data = response.data
          this.user_data = data.data
        }
      },


      //标签数据
      async get_label_data() {
        // this.loading = true;
        const response = await API.GET('/omnis/system/label_manage/');
        if (response && response.data) {
          this.label_list = response.data.data
        }
        // this.loading = false


      },

    }
  }
</script>
<style scoped>
  .asset_user_from .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 14px;
  }

  .label-span-box {

  }

  .label-svg {
    width: 1.3em;
    height: 1.3em;
    top: 2px;
    color: #666
  }


  .contain-box{
    width: 100%;
    height: 100%;
  }

  .box-footer{
    padding:10px 20px 20px;
    text-align:right;
    -webkit-box-sizing:border-box;
    box-sizing:border-box;
  }

  .form-body{
    overflow-y: auto;
  }


</style>




// WEBPACK FOOTER //
// assert_manage.vue?9bdb9e8a